import { render, staticRenderFns } from "./CaseDetailTableHeading.vue?vue&type=template&id=3d4ebb8c&scoped=true&"
import script from "./CaseDetailTableHeading.vue?vue&type=script&lang=js&"
export * from "./CaseDetailTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./CaseDetailTableHeading.vue?vue&type=style&index=0&id=3d4ebb8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ebb8c",
  null
  
)

export default component.exports